/**
 * Returns true if item not undefined.
 *
 * @param item Item to check for undefined
 * @returns true if item not undefined
 */
export function nonNullable<TItem>(item: TItem | null | undefined): item is TItem {
  return item !== null && item !== undefined;
}
